"use client";
import {
  Link
} from "./chunk-NNKVN7WA.js";
import "./chunk-FVY6EZ3N.js";
import "./chunk-MLKGABMK.js";
export {
  Link as default
};
